export enum DiscountClass {
  ORDER = 'ORDER',
  PRODUCT = 'PRODUCT',
  SHIPPING = 'SHIPPING',
}

export type PromoCode = {
  code: string;
  discountClass: DiscountClass;
  message: string;
};
